import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

@Component({
  selector: "myqq-generic-confirm",
  templateUrl: "./generic-confirm.component.html",
  styleUrls: ["./generic-confirm.component.scss"],
  standalone: false,
})
export class GenericConfirmComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: { title: string; message: string | string[] },
    public dialogRef: MatDialogRef<GenericConfirmComponent>
  ) {}

  get title() {
    return (this.data && this.data.title) || "";
  }

  get message() {
    return (this.data && this.data.message) || "";
  }

  close(selection: boolean) {
    this.dialogRef.close(selection);
  }
}
